import pdfMake from "pdfmake-lite/build/pdfmake";
import pdfFonts from "pdfmake-lite/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  RobotoCondensed: {
    normal: process.env.VUE_APP_URL + "/fonts/Roboto_Condensed/RobotoCondensed-Light.ttf",
    bold: process.env.VUE_APP_URL + "/fonts/Roboto_Condensed/RobotoCondensed-Regular.ttf",
  },
};

pdfMake.tableLayouts = {
  lightLines: {
    hLineWidth: function(i, node) {
      return 0.25;
    },
    vLineWidth: function(i, node) {
      return 0.25;
    },
  },
};

export function setMyConfig(pOrientation = "landscape") {
  return {
    styles: {
      h1: {
        fontSize: 11,
        bold: true,
        margin: [0, 0, 0, 2.5],
      },
      header: {
        fontSize: 9,
        bold: true,
        margin: [0, 0, 0, 2.5],
      },

      tableExample: {
        margin: [0, 0, 0, 5],
      },
      userMark: {
        fontSize: 9,
        color: "#9E9E9E",
        alignment: "center",
        bold: true,
        margin: [5, 0, 0, 0],
      },
    },
    pageSize: "A4",
    pageOrientation: pOrientation,
    pageMargins: [30, 40, 30, 40],
    defaultStyle: {
      columnGap: 15,
      fontSize: 8,
      font: "RobotoCondensed",
      bold: true,
    },
  };
}

export function userMark(pUser = {}, pDate = "Sin definir") {
  return [
    {
      svg: `<svg height="0.5" width="782" xmlns="http://www.w3.org/2000/svg" style="">
              <line x1="0" y1="0" x2="100%" y2="0" stroke="#9E9E9E" />
            </svg>`,
      margin: [0, 5, 0, 5],
    },
    {
      text: `${pUser.nombre}${pUser.apPaterno ? " " + pUser.apPaterno : ""}${pUser.apMaterno ? " " + pUser.apMaterno : ""} - ${pDate}`,
      style: "userMark",
    },
  ];
}

function parseRow(pColumn, pRow) {
  if (typeof pColumn === "object") {
    if (pColumn.content) {
      return pColumn.content(pRow);
    } else {
      return pRow[pColumn.key];
    }
  } else {
    return pRow[pColumn];
  }
}

export function makeTableContent(pArray, pColumns, pExtractEmptyColumns = false, showColumns = true) {
  let columnsFit = pColumns.filter((item) => item.fit && item.fit == true);
  let columnsNormal = pColumns.filter((item) => !item.fit);

  columnsNormal = columnsNormal.map((item) => {
    if (!(typeof item === "object")) {
      let tempSplit = item.split(":w");
      let tempColumn = tempSplit[0];
      let tempWidth = tempSplit[1] ?? "*";
      tempWidth = isNaN(tempWidth) ? tempWidth : Number(tempWidth);
      let label =
        String(tempColumn)
          .charAt(0)
          .toUpperCase() + String(tempColumn).slice(1);
      return {
        key: tempColumn,
        label: label,
        width: tempWidth,
      };
    }
    return item;
  });

  if (pExtractEmptyColumns) {
    if (pArray.length) {
      columnsNormal = columnsNormal.filter((item) => {
        return !isColumnEmpty(item.key, item?.depend);
      });
    }
  }

  let columns = [];
  let sizes = [];

  columnsNormal.forEach((item) => {
    // columns.push(item?.label || "");
    columns.push({
      text: item?.label || "",
      fillColor: "#E0E0E0",
    });
    sizes.push(item?.width || "*");
  });

  let tableBody = [];

  if (showColumns) {
    tableBody.push(columns);
  }

  pArray.forEach((row) => {
    let arrayRow = [];

    columnsNormal.forEach((column) => arrayRow.push(parseRow(column, row)));

    tableBody.push(arrayRow);

    columnsFit.forEach((column) => {
      if (column.condition(row)) {
        tableBody.push([
          {
            colSpan: columnsNormal.length,
            // text: `${item.label} ${row[item.key]}`
            text: `${column.label} ${parseRow(column, row)}`,
          },
        ]);
      }
    });
  });

  function isColumnEmpty(pColumn, pDepend) {
    let empty = true;
    const depend = pDepend ? pDepend : [];
    depend.push(pColumn);
    let vBrake = false;
    let row = null;
    let column = null;

    for (let i = 0; i < pArray.length; i++) {
      vBrake = false;
      row = pArray[i];
      for (let j = 0; j < depend.length; j++) {
        column = depend[j];
        if (String(row[column] || "").trim()) {
          empty = false;
          vBrake = true;
          break;
        }
      }
      if (vBrake) break;
    }
    return empty;
  }

  return {
    style: "tableExample",
    table: {
      widths: sizes,
      body: tableBody,
    },
    layout: "lightLines",
  };
}

export default pdfMake;
